var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bas-dropdown",
    class: {
      collapsed: _vm.collapsed
    }
  }, [_vm.label ? _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")])]) : _vm._e(), _c('div', {
    staticClass: "dropdown-container"
  }, [_c('button', {
    staticClass: "header pure-button",
    attrs: {
      "aria-expanded": _vm.collapsed,
      "aria-label": _vm.label,
      "aria-haspopup": "true",
      "aria-controls": "dropdownmenu",
      "id": "dropdownbutton",
      "tabindex": "0"
    },
    on: {
      "click": _vm.onDropDownClick,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.onDropDownClick($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.onDropDownClick($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.onDropDownClick($event);
      }]
    }
  }, [_vm.selection ? _c('div', {
    staticClass: "selection-overlay"
  }, [_c('span', [_vm._v(_vm._s(_vm.selection))])]) : _vm._e(), _c('div', {
    staticClass: "left"
  }), _vm._m(0)]), _vm.collapsed ? _c('ul', {
    staticClass: "options-container",
    attrs: {
      "aria-label": "Dropdown Options",
      "id": "dropdownmenu",
      "role": "menu"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: index,
      class: ("option dropdown-" + (_vm.dropDownId) + "-option"),
      attrs: {
        "data-index": index,
        "role": "menuitem",
        "tabindex": "0"
      },
      on: {
        "blur": _vm.handleBlur,
        "click": function ($event) {
          return _vm.handleSelection(option.label ? option.label : option);
        },
        "focus": function (e) {
          return _vm.focusedOption = e.target;
        },
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleSelection(option.label ? option.label : option);
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          return _vm.shiftOptionFocus(_vm.options.length - 1 === index ? index : index + 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return function () {
            return _vm.collapsed = false;
          }($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          return _vm.shiftOptionFocus(index ? index - 1 : index);
        }]
      }
    }, [_vm._v("\n        " + _vm._s(option.label ? option.label : option) + "\n      ")]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]);
}]

export { render, staticRenderFns }